export default "__VITE_ASSET__HN8h_lU1__"